module.exports = __webpack_public_path__ + "img/buffertrails.ced33ccd.jpeg";